import { IonButton, IonInput, IonModal, useIonAlert } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import DatePickerComponent from "../DatePicker/datepicker-component";
import TimePicker from "../TimePicker/timepicker-component";
import "./TeamCreationModal.scss";
import { useToast } from "@agney/ir-toast";
import { useHistory } from "react-router";
import DropDown from "../Dropdown/dropdown-component";
import { utilService } from "../../../services/utilService";
import { setTeamCreation } from "./TeamCreationModal.service";
import moment from "moment";
import { useTranslation } from "react-i18next";

interface TeamCreationProps {
  showModal: boolean;
  onCancel: () => void;
  onOk: () => void;
  fromAccordionUserCard?: any;
  teamDetails?: any;
  teamId?: any;
  teamEdit?: boolean;
  updateTeamList?: any;
  editUserTimeSpan?: boolean;
  selectedTeamDetails?: any;
  createTeam?: boolean;
  joinToTeam?: boolean;
  selectedUserData?: any;
  fullTeamList?: any;
}
const TeamCreation: React.FC<TeamCreationProps> = (props: any) => {
  
  const { t } = useTranslation("teams");
  const today = utilService.getCurrentDate();
  const [selectedStartDate, setSelectedStartDate] = useState<any>(today);
  const [selectedEndDate, setSelectedEndDate] = useState<any>(today);
  const [selectedStartTime, setSelectedStartTime] = useState<any>(
    utilService.getFormattedCurrentTime()
  );
  const [selectedEndTime, setSelectedEndTime] = useState<any>(
    utilService.getFormattedCurrentTime()
  );
  const [teamName, setTeamName] = useState<any>("");
  const [siteList, setSiteList] = useState<any>([]);
  const [selectedSite, setSelectedSite] = useState<any>();
  const [teamMatesDates, setTeamMatesDates] = useState<any>([]);
  const [teamMatesExpTime, setTeamMatesExpTime] = useState<any>([]);
  const [updateTeamBtn, setUpdateTeamBtn] = useState(false);
  const [enableContinueBtn, setEnableContinueBtn] = useState(false);
  const [enableWarningMessage, setWarningMessage] = useState("");
  const [enableWarningSection, setEnableWarningSection] = useState(false);
  const [showStartDatePickerModal, setStartDatePickerModal] = useState(false);
  const [showStartTimePickerModal, setStartTimePickerModal] = useState(false);
  const [showExpiryDatePickerModal, setExpiryDatePickerModal] = useState(false);
  const [showExpiryTimePickerModal, setExpiryTimePickerModal] = useState(false);
  const [formattedStartTime, setFormattedStartTime] = useState<any>();
  const [formattedEndTime, setFormattedEndTime] = useState<any>();
  const [fromUpdateTimeSpan, setFromUpdateTimeSpan] = useState(false);

  const [presentAlert] = useIonAlert();

  let history = useHistory();
  const Toast = useToast();

  useEffect(() => {
    if (props.createTeam) {
      getSiteList();
    }
  }, [props.createTeam]);

  useEffect(() => {
    let teamStartTime = moment(
      props.teamDetails?.teamStartTime,
      "HH:mm A"
    ).format("hh:mm A");
    let teamEndTime = moment(
      props.teamDetails?.teamExpiryTime,
      "HH:mm A"
    ).format("hh:mm A");
    if (props.teamEdit) {
      setEnableContinueBtn(true);
      checkTimeSpan(props.teamDetails);
      setTeamName(props.teamDetails?.teamName);
      setSelectedSite(props.teamDetails?.teamSiteId);
      setSelectedStartDate(props.teamDetails?.teamStartDate);
      setSelectedStartTime(teamStartTime);
      setSelectedEndTime(teamEndTime);
      setSelectedEndDate(props.teamDetails?.teamExpiryDate);
      getSiteList();
    }

    if (props.editUserTimeSpan) {
      setSelectedStartDate(props.selectedUserData?.teamStartDate);
      setSelectedEndDate(props.selectedUserData?.teamExpiryDate);
      if (!fromUpdateTimeSpan) {
        let teamStartTime = moment(
          props.selectedUserData?.teamStartTime,
          "HH:mm"
        ).format("hh:mm A");
        let teamEndTime = moment(
          props.selectedUserData?.teamExpiryTime,
          "HH:mm A"
        ).format("hh:mm A");
        setSelectedStartTime(teamStartTime);
        setSelectedEndTime(teamEndTime);
      } else {
        let teamStartTime = moment(selectedStartTime, "HH:mm").format(
          "hh:mm A"
        );
        let teamEndTime = moment(selectedEndTime, "HH:mm A").format("hh:mm A");
        setSelectedStartTime(teamStartTime);
        setSelectedEndTime(teamEndTime);
      }
    }

    if (props.joinToTeam) {
      setSelectedStartDate(props.teamDetails?.teamStartDate);
      setSelectedEndDate(props.teamDetails?.teamExpiryDate);

      setSelectedStartTime(teamStartTime);
      setSelectedEndTime(teamEndTime);
    }
  }, [props.showModal]);

  const getSiteList = async () => {
    let params;
    const apiResponse = await setTeamCreation.getSites(params);
    if (apiResponse.isSuccess) {
      setSiteList(apiResponse.siteData);
    }
  };

  const checkTimeSpan = (teamDetails: any) => {
    let team_user: any = teamDetails?.scheduleDoctorList;

    if (team_user) {
      expiryDateTempArray(team_user);
      expiryTimeTempArray(team_user);
    }
  };

  const expiryDateTempArray = (team_users: any) => {
    const keys_ExpiryDate = ["teamExpiryDate"];
    const expiry_Date_Result = team_users.map((data: { [x: string]: any }) => {
      const new_Exp_Date_obj: any = {};
      keys_ExpiryDate.forEach(
        (dateItem) => (new_Exp_Date_obj[dateItem] = data[dateItem])
      );
      return new_Exp_Date_obj;
    });
    setTeamMatesDates(expiry_Date_Result);
  };

  const expiryTimeTempArray = (team_users: any) => {
    const keys_ExpiryDate = ["teamExpiryTime"];
    const expiry_Date_Result = team_users.map((data: { [x: string]: any }) => {
      const new_Exp_Date_obj: any = {};
      keys_ExpiryDate.forEach(
        (dateItem) => (new_Exp_Date_obj[dateItem] = data[dateItem])
      );
      return new_Exp_Date_obj;
    });
    setTeamMatesExpTime(expiry_Date_Result);
  };

const createTeam = () => {
  let validationStatus = true;
  let currTime = utilService.getCurrentTime();
  let sameDate;

  if (props.fullTeamList?.find((team: any) => team?.teamName === teamName)) {
    Toast.error(t("teamNameExists"));
    validationStatus = false;
  } else if (
    selectedStartDate === today &&
    moment(selectedStartTime, "hh:mm A").isBefore(moment(currTime, "HH:mm"))
  ) {
    Toast.error(t("invalidStartDateTime"));
    validationStatus = false;
  } else if (
    selectedEndDate === today &&
    moment(selectedEndTime, "hh:mm A").isBefore(moment(currTime, "HH:mm"))
  ) {
    Toast.error(t("invalidExpiryDateTime"));
    validationStatus = false;
  }

  if (selectedStartDate === selectedEndDate) {
    sameDate = true;
  } else {
    sameDate = false;
  }

  if (selectedStartTime === selectedEndTime) {
    if (sameDate) {
      Toast.error(t("invalidExpiryTime"));
      validationStatus = false;
    }
  }

  if (selectedStartTime > selectedEndTime) {
    if (sameDate) {
      Toast.error(t("invalidExpiryTime"));
      validationStatus = false;
    }
  }

  if (!(selectedStartDate <= selectedEndDate)) {
    Toast.error(t("invalidEndDate"));
    validationStatus = false;
  }

  if (!teamName) {
 Toast.error(t("enterTeamName"));
    validationStatus = false;
  }

  if (validationStatus) {
    enableRedirect();
  }
};

  const joinToTeam = async () => {
    let validationStatus = true;

    let teamStartTimeFormat = moment(
      props.teamDetails?.teamStartTime,
      "HH:mm A"
    ).format("hh:mm A");

    let teamEndTimeFormat = moment(
      props.teamDetails?.teamExpiryTime,
      "HH:mm A"
    ).format("hh:mm A");

    let teamStartDateTime =
      props.teamDetails?.teamStartDate + " " + teamStartTimeFormat;
    let teamEndDateTime =
      props.teamDetails?.teamExpiryDate + " " + teamEndTimeFormat;

    let selectedStartDateTime = selectedStartDate + " " + selectedStartTime;
    let selectedEndDateTime = selectedEndDate + " " + selectedEndTime;

    let selectedStartDateTimeFormat = moment(
      selectedStartDate + " " + selectedStartTime,
      "YYYY-MM-DD hh:mm A"
    ).format("YYYY-MM-DDTHH:mm A");

    let teamStartTime = moment(selectedStartTime, "h:mm:ss A").format("HH:mm");
    let teamEndTime = moment(selectedEndTime, "h:mm:ss A").format("HH:mm");

    const currentDate = moment().format("YYYY-MM-DD");

    if (moment(selectedStartDateTime).isBefore(moment().startOf("day"))) {
      Toast.error("Please select a different start date and time");
      validationStatus = false;
    } else if (moment(selectedStartDateTime).isSameOrBefore(moment())) {
      if (moment(selectedStartTime, "h:mm:ss A").isSame(moment(), "minute")) {
      } else {
        Toast.error("Please select a different start date and time");
        validationStatus = false;
      }
    }

    if (
      moment(selectedStartDateTime).isSameOrBefore(moment().startOf("day")) &&
      moment(selectedEndDateTime).isAfter(moment().endOf("day"))
    ) {
      Toast.error("Please select a different start date and time");
      validationStatus = false;
    }

    if (
      moment(selectedStartDateTime).isSame(moment().startOf("day")) &&
      teamStartDateTime > selectedStartDateTime
    ) {
      Toast.error("Please select a different start date and time");
      validationStatus = false;
    }

    if (moment(selectedEndDateTime).isBefore(moment(teamStartDateTime))) {
      Toast.error("Please select a different end date and time");

      validationStatus = false;
    }

    if (
      moment(selectedEndDateTime).isSameOrAfter(moment().endOf("day")) &&
      teamEndDateTime < selectedEndDateTime
    ) {
      Toast.error("Please select a different end date and time");

      validationStatus = false;
    }

    if (moment(selectedStartDateTime).isAfter(moment(selectedEndDateTime))) {
      Toast.error("Please select a different end date and time");

      validationStatus = false;
    }

    if (validationStatus) {
      let params = setParams();
      params.start_time = teamStartTime;
      params.expiry_time = teamEndTime;
      const apiResponse = await setTeamCreation.joinToTeam(params);
      if (apiResponse.isSuccess) {
        props.updateTeamList(apiResponse.isSuccess);
        if (
          moment(selectedStartDateTimeFormat, "YYYY-MM-DDTHH:mm A").isAfter(
            moment()
          )
        ) {
         presentAlert({
  message: t("addedToTeamFuture"),
  buttons: [t("ok")],
});
        } else {
        Toast.success(t("addedToTeam"));
        }

        props.onCancel();
      }
    }
  };

  const isInExpDateArray = (array: any, value: any) => {
    for (var i = 0; i < array.length; i++) {
      if (value < array[i].teamExpiryDate) {
        return true;
      }
    }
    return false;
  };

  const isInExpTimeArray = (array: any, value: any) => {
    for (var i = 0; i < array.length; i++) {
      if (value < array[i].teamExpiryTime) {
        return true;
      }
    }
    return false;
  };

  const updateTeam = () => {
    let endDateCheck = isInExpDateArray(teamMatesDates, selectedEndDate);
    let endTimeCheck = isInExpTimeArray(teamMatesExpTime, selectedEndTime);
    let currTime = utilService.getCurrentTime();

    if (endDateCheck || endTimeCheck) {
     setWarningMessage(t("modifyTeammatesWarning"));
      setEnableWarningSection(true);
    }

    if (!teamName) {
      Toast.error("Please enter team name to continue");
    } else if (
      moment(selectedStartDate, "YYYY-MM-DD").isAfter(
        moment(selectedEndDate, "YYYY-MM-DD")
      )
    ) {
      Toast.error(t("invalidExpiry"));
    } else if (
      selectedStartDate === selectedEndDate &&
      selectedStartTime === selectedEndTime
    ) {
      Toast.error(t("invalidExpiry"));
    } else if (
      selectedStartDate === selectedEndDate &&
      moment(selectedStartTime, "hh:mm A").isAfter(
        moment(selectedEndTime, "hh:mm A")
      )
    ) {
     Toast.error(t("invalidExpiry"));
    } else if (
      selectedStartDate === today &&
      moment(selectedStartTime, "hh:mm A").isBefore(moment(currTime, "HH:mm"))
    ) {
     Toast.error(t("invalidStart"));
    } else if (
      selectedEndDate === today &&
      moment(selectedEndTime, "hh:mm A").isBefore(moment(currTime, "HH:mm"))
    ) {
      Toast.error(t("invalidExpiry"));
    } else {
      // setWarningMessage("");
      // setEnableWarningSection(false);
      // updateTeamData();
      setUpdateTeamBtn(true);
      setEnableContinueBtn(false);
    }
  };

  const updateTeamData = async () => {
    let params = setUpdateTeamParams();

    const selectedStartTimeFormat = moment(selectedStartTime, "hh:mm A").format(
      "HH:mm"
    );
    const selectedEndTimeFormat = moment(selectedEndTime, "hh:mm A").format(
      "HH:mm"
    );
    params.start_time = selectedStartTimeFormat;
    params.expiry_time = selectedEndTimeFormat;

    const apiResponse = await setTeamCreation.updateTeam(params);
    if (apiResponse.isSuccess) {
      Toast.success(t("teamUpdatedSuccess"));
      props.updateTeamList(apiResponse.isSuccess);
    }
  };

  const updateTimeSpan = async () => {
    setFromUpdateTimeSpan(true);
    let params = setUpdateTimeParams();
    var strttime = moment(params.start_time, ["h:mm A"]).format("HH:mm");
    var endtime = moment(params.expiry_time, ["h:mm A"]).format("HH:mm");
    params.start_time = strttime;
    params.expiry_time = endtime;
    if (props.selectedTeamDetails.teamExpiryDate === selectedStartDate) {
      Toast.error("Please choose another start date");
    } else if (
      moment(params.start_date, "YYYY-MM-DD").isAfter(
        moment(props?.selectedUserData?.teamExpiryDate, "YYYY-MM-DD")
      )
    ) {
      Toast.error(
        "Selected start date/time is greater than team expiry date/time"
      );
    } else if (
      params.start_date === params.expiry_date &&
      params.start_time === params.expiry_time
    ) {
      Toast.error("Selected start date/time is same as expiry date/time");
    } else if (
      params.start_date === params.expiry_date &&
      moment(params.start_time, "HH:mm").isAfter(
        moment(params.expiry_time, "HH:mm")
      )
    ) {
      Toast.error("Selected start date/time is greater than expiry date/time");
    } else if (
      params.expiry_date === props.selectedUserData?.teamExpiryDate &&
      moment(params?.expiry_time, "HH:mm").isAfter(
        moment(props?.selectedUserData?.teamExpiryTime, "HH:mm")
      )
    ) {
      Toast.error("Selected expiry date/time is greater than team expiry date/time");
    } else {
      const apiResponse = await setTeamCreation.updateTimeSpan(params);
      props.onCancel();
      if (apiResponse.isSuccess) {
        Toast.success(CONSTANTS.MESSAGES.UPDATED_FAVORITE_SUCCESS);
        props.updateTeamList(apiResponse.isSuccess);
      }
    }
  };

  const setUpdateTimeParams = () => {
    const params = {
      team_id: props.teamId,
      start_date: selectedStartDate,
      start_time: selectedStartTime,
      expiry_date: selectedEndDate,
      expiry_time: selectedEndTime,
      user_guid: utilService.getLoggedUserGuid(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    return params;
  };

  const setUpdateTeamParams = () => {
    const params = {
      team_id: props.teamId,
      start_date: selectedStartDate,
      start_time: selectedStartTime,
      expiry_date: selectedEndDate,
      expiry_time: selectedEndTime,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      site: selectedSite,
      team_name: teamName,
    };
    return params;
  };

  const setParams = () => {
    const params = {
      team_id: props.teamId,
      start_date: selectedStartDate,
      start_time: selectedStartTime,
      expiry_date: selectedEndDate,
      expiry_time: selectedEndTime,
      user_guid: utilService.getLoggedUserGuid(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    return params;
  };

  const enableRedirect = () => {
    history.push({
      pathname: "/client/file-share/addTeammates",
      state: {
        team_name: teamName,
        site: setSelectedSiteValue(),
        start_date: selectedStartDate,
        start_time: moment(selectedStartTime, "hh:mm A").format("HH:mm"),
        expiry_date: selectedEndDate,
        expiry_time: moment(selectedEndTime, "hh:mm A").format("HH:mm"),
      },
    });
  };

  const setSelectedSiteValue = () => {
    if (selectedSite >= 0) {
      return selectedSite;
    } else {
      return null;
    }
  };

  const convertDate = (time: any) => {
    return moment(time).format("MMM DD, YYYY");
  };

const getModalTile = () => {
  if (props.fromAccordionUserCard && !props.editUserTimeSpan) {
    return t("joinTeam");
  } else if (props.teamEdit) {
    return t("editTeam");
  } else if (props.createTeam) {
    return t("teamCreation");
  }
};

  return (
    <>
      <IonModal
        isOpen={props.showModal}
        className={`team-creation-modal ${
          props.fromAccordionUserCard ? "join-team-list" : ""
        }`}
        backdropDismiss={false}
      >
        <div className="alert-main-container">
          <div className="content-area-teams">
            <h3 className="label"> {getModalTile()}</h3>
            {props.fromAccordionUserCard && !props.editUserTimeSpan && (
              <div className="col-md-12 mb-3">
               <p>
  {t("teamStartsOn")} {convertDate(props.teamDetails?.teamStartDate)}, {props.teamDetails?.teamStartTime}
</p>

               <p>
  {t("teamExpiresOn")} {convertDate(props.teamDetails?.teamExpiryDate)}, {props.teamDetails?.teamExpiryTime}
</p>
              </div>
            )}

            <div className="form-row" hidden={props.fromAccordionUserCard}>
              <div className="col-md-12 mb-3">
                <label htmlFor="validationServer013">
               {t("teamName")} <span className="ocl-star">*</span>
                </label>
                <input
                  type="text"
                  className="form-control emt-sac-input"
                  id="field-1"
                 placeholder={t("teamName")}
                  value={teamName}
                  onChange={(e) => {
                    setTeamName(e.target.value);
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                />
              </div>
            </div>
            <div className="form-row" hidden={props.fromAccordionUserCard}>
              <div className="col-md-12 mb-3">
                <label htmlFor="validationServer013">{t("selectSite")}</label>
                <DropDown
                  siteListData={siteList}
                  getSelectedItem={(value: number) => {
                    setSelectedSite(value);
                  }}
                  selectedSiteData={props.teamDetails?.teamSiteId}
                  // selectedSiteData ={handleSiteSelection}
                  isFromTeams={true}
                ></DropDown>
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label htmlFor="validationServer013">
                {t("startDate")} <span className="ocl-star">*</span>
                </label>
                <div className="input-section">
                  <IonInput
                    id="inputSec"
                    name="display"
                    className="form-control emt-sac-input"
                    value={utilService.getDayFormat(selectedStartDate)}
                    onClick={() => setStartDatePickerModal(true)}
                    readonly
                  ></IonInput>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="validationServer013">
                  {t("time")} <span className="ocl-star">*</span>
                </label>
                <div className="input-section">
                  <IonInput
                    id="inputSec"
                    name="display"
                    className="form-control selectedTimeInput"
                    value={selectedStartTime}
                    onClick={() => setStartTimePickerModal(true)}
                    readonly
                  ></IonInput>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label htmlFor="validationServer013">
                 {t("endDate")}<span className="ocl-star">*</span>
                </label>
                <div className="input-section">
                  <IonInput
                    id="inputSec"
                    name="display"
                    className="form-control emt-sac-input"
                    value={utilService.getDayFormat(selectedEndDate)}
                    onClick={() => setExpiryDatePickerModal(true)}
                    readonly
                  ></IonInput>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="validationServer013">
                 { t("time")} <span className="ocl-star">*</span>
                </label>
                <div className="input-section">
                  <IonInput
                    id="inputSec"
                    name="display"
                    className="form-control selectedTimeInput"
                    value={selectedEndTime}
                    onClick={() => setExpiryTimePickerModal(true)}
                    readonly
                  ></IonInput>
                </div>
              </div>
            </div>
          </div>

          <div className="warning-message" hidden={!enableWarningSection}>
            <p>{enableWarningMessage}</p>
          </div>

          <div className="alert-button-container">
            <div className="cancel-button-div">
              <IonButton
                color="medium"
                className="cancel-button secondary-btn button btn-curved"
                onClick={() => {
                  props.onCancel();
                  setTeamName("");
                  setSelectedStartDate("");
                  setSelectedStartTime(utilService.getFormattedCurrentTime());
                  setSelectedEndDate("");
                  setSelectedEndTime(utilService.getFormattedCurrentTime());
                  setWarningMessage("");
                  setEnableWarningSection(false);
                  setUpdateTeamBtn(false);
                }}
              >
               {t("cancel")}
              </IonButton>
            </div>
            <div className="send-button-div" hidden={!props.createTeam}>
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  createTeam();
                }}
              >
                {t("create")}
              </IonButton>
            </div>

            <div className="send-button-div" hidden={!props.joinToTeam}>
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  joinToTeam();
                }}
              >
                {t("join")}
              </IonButton>
            </div>

            <div className="send-button-div" hidden={!enableContinueBtn}>
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  updateTeam();
                }}
              >
              {t("continue")}
              </IonButton>
            </div>

            <div className="send-button-div" hidden={!updateTeamBtn}>
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  updateTeamData();
                  props.onCancel();
                  setWarningMessage("");
                  setEnableWarningSection(false);
                  setUpdateTeamBtn(false);
                }}
              >
                {t("update")}
              </IonButton>
            </div>

            <div className="send-button-div" hidden={!props.editUserTimeSpan}>
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  updateTimeSpan();
                }}
              >
             {t("update")}
              </IonButton>
            </div>
          </div>
        </div>
      </IonModal>
      <IonModal
        isOpen={showStartDatePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <DatePickerComponent
          dateFromParent={selectedStartDate}
          isFromEMS={true}
          isDateShort={true}
          getSelectedDate={(value: string) => {
            setSelectedStartDate(value);
          }}
        ></DatePickerComponent>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setStartDatePickerModal(false);
              }}
            >
            {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonModal
        isOpen={showStartTimePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <TimePicker
          getSelectedTime={(value: string) => {
            if (value) {
              let formattedStartTime = moment(value, "HH:mm").format("hh:mm A");
              setSelectedStartTime(formattedStartTime);
              setFormattedStartTime(value);
            }
          }}
        ></TimePicker>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setStartTimePickerModal(false);
              }}
            >
            {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonModal
        isOpen={showExpiryDatePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <DatePickerComponent
          dateFromParent={selectedEndDate}
          isFromEMS={true}
          isDateShort={true}
          getSelectedDate={(value: string) => {
            setSelectedEndDate(value);
          }}
        ></DatePickerComponent>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setExpiryDatePickerModal(false);
              }}
            >
          {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonModal
        isOpen={showExpiryTimePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <TimePicker
          getSelectedTime={(value: string) => {
            if (value) {
              let formattedEndTime = moment(value, "HH:mm").format("hh:mm A");
              setSelectedEndTime(formattedEndTime);
              setFormattedEndTime(value);
            }
          }}
        ></TimePicker>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setExpiryTimePickerModal(false);
              }}
            >
             {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </>
  );
};

export default TeamCreation;
